<template>
  <div class="maincont" id="activity">
    <div class="ef--inner2 filter">

      <!--*************************************************************---
      <--- タブ
      <--*************************************************************-->
      <div id="tab_info" class="tab-info">
        <div id="tab_group" class="tab active" v-on:click="onTabClick('tab_group')" v-if="this.$store.state.loginType != 3">グループアカウント</div>
        <div id="tab_power" class="tab inactive" v-on:click="onTabClick('tab_power')">電力見える化アカウント</div>
        <div id="tab_es" class="tab inactive" v-on:click="onTabClick('tab_es')" v-if="this.$store.state.loginType != 3">ESアカウント</div>
      </div>

      <div id="page_info" class="page-info page-info-frame">

        <!--*************************************************************---
        <--- グループアカウント一覧
        <--*************************************************************-->
        <div id="tab_group" class="display-block">
          <div class="block-info display-block">
            <div class="list-info" style="height:681px;">
              <table class="list-table">
                <thead>
                  <tr>
                    <th rowspan="3" width="7%">アカウントNo.</th>
                    <th rowspan="3" width="20%">お客さま名</th>
                    <th rowspan="3" width="4%">箇所数</th>
                    <th rowspan="3">シングルアカウント一覧</th>
                    <th colspan="6">電力見える化</th>
                    <th colspan="2">ES</th>
                    <th rowspan="3" width="3%">詳細</th>
                  </tr>
                  <tr>
                    <th rowspan="2" width="3%">設備</th>
                    <th colspan="2">デマンド</th>
                    <th colspan="3">警報数</th>
                    <th rowspan="2" width="3%">設備<br/></th>
                    <th rowspan="2" width="4%">発生中<br/>警報数</th>
                  </tr>
                  <tr>
                    <th width="6%">目標値</th>
                    <th width="6%">予測値</th>
                    <th width="4%">現在</th>
                    <th width="4%">当日</th>
                    <th width="4%">当月</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in group_info.activities" v-bind:key="index">
                    <!------------------------------------------------------------------
                    <-- アカウントNo
                    <------------------------------------------------------------------>
                    <td>{{ item.account }}</td>

                    <!------------------------------------------------------------------
                    <-- お客さま名
                    <------------------------------------------------------------------>
                    <td style="text-align:left">{{ item.name }} さま</td>

                    <!------------------------------------------------------------------
                    <-- 個所数
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.chain_count) }}</span> 店</td>

                    <!------------------------------------------------------------------
                    <-- シングルアカウント一覧
                    <------------------------------------------------------------------>
                    <td style="text-align:left;">{{ item.chain_list }}</td>

                    <!------------------------------------------------------------------
                    <-- (電力見える化)設備
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <a
                        href="javascript:void(0);"
                        @click="onDetailPower(item.name)"
                      >
                        <img v-bind:src="isFunction(item.power_info.account_count)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (電力見える化)(デマンド)目標値
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ item.power_info.account_count > 0 ? numComma(item.power_info.contract_power) : "-" }}</span> kW</td>

                    <!------------------------------------------------------------------
                    <-- (電力見える化)(デマンド)予測値
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ item.power_info.account_count > 0 ? numComma(item.power_info.demand_forecast) : "-" }}</span> kW</td>

                    <!------------------------------------------------------------------
                    <-- (電力見える化)(警報数)現在
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ item.power_info.account_count > 0 ? numComma(item.power_info.alert_count_now) : "-" }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- (電力見える化)(警報数)当日
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ item.power_info.account_count > 0 ? numComma(item.power_info.alert_count_today) : "-" }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- (電力見える化)(警報数)当月
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ item.power_info.account_count > 0 ? numComma(item.power_info.alert_count_month) : "-" }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- (ES)設備
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <a
                        href="javascript:void(0);"
                        @click="onDetailEs(item.name)"
                      >
                        <img v-bind:src="isFunction(item.es_info.account_count)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (ES)発生中警報数
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ item.es_info.account_count > 0 ? numComma(item.es_info.alert_count) : "-" }}</span> 件</td>

                    <!------------------------------------------------------------------
                    <-- 詳細
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <a href="javascript:void(0);" @click="onDetailParent(item.account, item.supply_management)">
                        <img src="/assets/images/activity/icon.detail.png" />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

        <!--*************************************************************---
        <--- シングルアカウント一覧
        <--*************************************************************-->
        <div id="tab_power" style="display:none">
          <!--=============================================================---
          <--- 絞込
          <--=============================================================-->
          <div class="block-info display-block">
            <div class="filter-info display-flex">
              <div class="header-info">条 件</div>

              <div class="line-info display-flex">
                <!------------------------------------------------------------------
                <-- グループアカウント名
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="parent_name">グループアカウント名</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="normal"
                      v-model="power_info.filter_info.parent_name"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- アカウントNo.
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="account">アカウントNo.</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="small"
                      v-model="power_info.filter_info.account"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- お客さま名
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="company_name">お客さま名</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="normal"
                      v-model="power_info.filter_info.company_name"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 支店
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="sales_center_id">支店</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="eigyo-center"
                      name="eigyo-center"
                      v-model="power_info.filter_info.sales_center_id"
                    >
                      <option value = ""></option>
                      <option
                        v-for="(option, index) in $store.state.salesCenterMaster"
                        v-bind:value="option.sales_center_id"
                        v-bind:key="index"
                      >{{ option.sales_center_name }}</option>
                    </select>
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 営業所
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="sales_office_id">営業所</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="eigyosho"
                      name="eigyosho"
                      v-model="power_info.filter_info.sales_office_id"
                    >
                      <option value = ""></option>
                      <option
                        v-for="(option, index) in power_info.filter_info.sales_office_ids"
                        v-bind:value="option.sales_office_id"
                        v-bind:key="index"
                      >{{ option.sales_office_name }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="footer-info display-flex">
                <input
                  type="button"
                  class="mini"
                  id="filter"
                  value="絞 込"
                  @click="onFilterPower()"
                />
              </div>
            </div>
          </div>

          <!--=============================================================---
          <--- リスト(シングルアカウント一覧)
          <--=============================================================-->
          <div class="block-info display-block">
            <div class="list-info" style="height:610px;">
              <table class="list-table">
                <thead>
                  <tr>
                    <th width="7%"><a href="javascript:void(0);" @click="onSortPower('account')">アカウントNo.</a></th>
                    <th><a href="javascript:void(0);" @click="onSortPower('name')">お客さま名</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortPower('master_batt')">電池残量<br/>(親機)</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortPower('slave_batt')">電池残量<br/>(子機)</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortPower('rssi')">電波強度</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortPower('air_conditioner_control')">空調機<br/>制御</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('control_status')">デマンド<br/>状態</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('contract_power')">デマンド<br/>目標値</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('today_max_demand')">当日最大<br/>デマンド</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('yesterday_max_demand')">前日最大<br/>デマンド</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('alert_count')">アラート<br/>通知回数</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('unit_alart_count_month')">当月の<br/>時限回数</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('unit_alart_count_total')">累積<br/>時限回数</a></th>
                    <th width="6%"><a href="javascript:void(0);" @click="onSortPower('forecast_demand')">本日のでんき<br/>予報リスク</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortPower('area_name')">計測地点</a></th>
                    <th width="4%">最終更新</th>
                    <th width="3%">詳細</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in power_info.filter_activities" v-bind:key="index">
                    <!------------------------------------------------------------------
                    <-- アカウントNo
                    <------------------------------------------------------------------>
                    <td>{{ item.account }}</td>

                    <!------------------------------------------------------------------
                    <-- お客さま名
                    <------------------------------------------------------------------>
                    <td>
                      <p v-if="item.parent_name == '' || item.parent_name == null">{{ item.name }} さま</p>
                      <p v-else>[ {{ item.parent_name }} ]<br>{{ item.name }} さま</p>
                    </td>

                    <!------------------------------------------------------------------
                    <-- 電池残量(親機)
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <img v-bind:src="getBatteryIconUrl(item.master_batt)" />
                      <!-- <img src="/assets/images/activity/icon.battery1.png"> -->
                    </td>

                    <!------------------------------------------------------------------
                    <-- 電池残量(子機)
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <img v-bind:src="getBatteryIconUrl(item.slave_batt)" />
                      <!-- <img src="/assets/images/activity/icon.battery1.png"> -->
                    </td>

                    <!------------------------------------------------------------------
                    <-- 電波状況
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <img v-bind:src="getDenpaIconUrl(item.rssi)" />
                      <!-- <img src="/assets/images/activity/icon.denpa1.png"> -->
                    </td>

                    <!------------------------------------------------------------------
                    <-- 空調機制御
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <label
                        v-bind:class="getSettingStatus(item.air_conditioner_control).color"
                      >
                        {{ getSettingStatus(item.air_conditioner_control).msg }}
                      </label>
                    </td>

                    <!------------------------------------------------------------------
                    <-- デマンド状態
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <label
                        v-bind:class="getDemandStatus(item.air_conditioner_control, item.control_status).back"
                      >
                        {{ getDemandStatus(item.air_conditioner_control, item.control_status).msg }}
                      </label>
                    </td>

                    <!------------------------------------------------------------------
                    <-- デマンド目標値
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.contract_power) }}</span> kW</td>

                    <!------------------------------------------------------------------
                    <-- 当日最大デマンド
                    <------------------------------------------------------------------>
                    <td style="text-align:right;">
                      <p>{{ item.today_max_time }}</p>
                      <span
                        v-bind:class="getDemandStatusComp(item.contract_power, item.today_max_demand).front"
                      >
                        {{ numComma(item.today_max_demand) }}
                      </span> kW
                    </td>

                    <!------------------------------------------------------------------
                    <-- 前日最大デマンド
                    <------------------------------------------------------------------>
                    <td style="text-align:right;">
                      <p>{{ item.yesterday_max_time }}</p>
                      <span
                        v-bind:class="getDemandStatusComp(item.contract_power, item.yesterday_max_demand).front"
                      >
                        {{ numComma(item.yesterday_max_demand) }}
                      </span> kW
                    </td>

                    <!------------------------------------------------------------------
                    <-- アラート通知回数
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.alert_count) }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- 当月の時限回数
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.unit_alart_count_month) }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- 累計時限回数
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.unit_alart_count_total) }}</span> 回</td>

                    <!------------------------------------------------------------------
                    <-- 本日のでんき予報リスク
                    <------------------------------------------------------------------>
                    <td style="text-align:right;">
                      <p>{{ getFormatForecastDate(item.forecast_date) }}</p>
                      <span>{{ numComma(normalizeForecastDemand(item.forecast_demand)) }}</span> kW
                    </td>

                    <!------------------------------------------------------------------
                    <-- 計測地点
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">{{ item.area_name }}</td>

                    <!------------------------------------------------------------------
                    <-- 最終更新
                    <------------------------------------------------------------------>
                    <td style="text-align:right;">{{ item.last_update_min }} 分前</td>

                    <!------------------------------------------------------------------
                    <-- 詳細
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <a href="javascript:void(0);" @click="onDetail(item.account, 0)">
                        <img src="/assets/images/activity/icon.detail.png" />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!--*************************************************************---
        <--- ESアカウント一覧
        <--*************************************************************-->
        <div id="tab_es" style="display:none">
          <!--=============================================================---
          <--- 絞込
          <--=============================================================-->
          <div class="block-info display-block">
            <div class="filter-info display-flex">
              <div class="header-info">条 件</div>

              <div class="line-info display-flex">
                <!------------------------------------------------------------------
                <-- グループアカウント名
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="parent_name">グループアカウント名</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="normal"
                      v-model="es_info.filter_info.parent_name"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- アカウントNo.
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="account">アカウントNo.</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="small"
                      v-model="es_info.filter_info.account"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- お客さま名
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="company_name">お客さま名</label>
                  <div class="body display-inline">
                    <input
                      type="text"
                      class="normal"
                      v-model="es_info.filter_info.company_name"
                    />
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 支店
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="sales_center_id">支店</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="eigyo-center"
                      name="eigyo-center"
                      v-model="es_info.filter_info.sales_center_id"
                    >
                      <option value = ""></option>
                      <option
                        v-for="(option, index) in $store.state.salesCenterMaster"
                        v-bind:value="option.sales_center_id"
                        v-bind:key="index"
                      >{{ option.sales_center_name }}</option>
                    </select>
                  </div>
                </div>

                <!------------------------------------------------------------------
                <-- 営業所
                <------------------------------------------------------------------>
                <div class="item-info display-flex">
                  <label class="title" for="sales_office_id">営業所</label>
                  <div class="body display-inline">
                    <select
                      class="small"
                      id="eigyosho"
                      name="eigyosho"
                      v-model="es_info.filter_info.sales_office_id"
                    >
                      <option value = ""></option>
                      <option
                        v-for="(option, index) in es_info.filter_info.sales_office_ids"
                        v-bind:value="option.sales_office_id"
                        v-bind:key="index"
                      >{{ option.sales_office_name }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="footer-info display-flex">
                <input
                  type="button"
                  class="mini"
                  id="filter"
                  value="絞 込"
                  @click="onFilterEs()"
                />
              </div>
            </div>
          </div>

          <!--=============================================================---
          <--- リスト(シングルアカウント(ES))
          <--=============================================================-->
          <div class="block-info display-block">
            <div class="list-info" style="height:610px;">
              <table class="list-table">
                <thead>
                  <tr>
                    <th rowspan="2" width="7%"><a href="javascript:void(0);" @click="onSortEs('account')">アカウントNo.</a></th>
                    <th rowspan="2" ><a href="javascript:void(0);" @click="onSortEs('name')">お客さま名</a></th>
                    <th colspan="2">発生中警報</th>
                    <th colspan="4">設備一覧</th>
                  </tr>
                  <tr>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortEs('alert_info.binary_minor')">軽故障</a></th>
                    <th width="4%"><a href="javascript:void(0);" @click="onSortEs('alert_info.binary_major')">重故障</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortEs('device_info.aircon.using')">空調</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortEs('device_info.receiver.using')">受変電</a></th>
                    <th width="3%"><a href="javascript:void(0);" @click="onSortEs('device_info.generator.using')">発電</a></th>
                    <th width="3%">その他</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in es_info.filter_activities" v-bind:key="index">
                    <!------------------------------------------------------------------
                    <-- アカウントNo
                    <------------------------------------------------------------------>
                    <td>{{ item.account }}</td>

                    <!------------------------------------------------------------------
                    <-- お客さま名
                    <------------------------------------------------------------------>
                    <td>
                      <p v-if="item.parent_name == '' || item.parent_name == null">{{ item.name }} さま</p>
                      <p v-else>[ {{ item.parent_name }} ]<br>{{ item.name }} さま</p>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (発生中警報)軽故障
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.alert_info.binary_minor) }}</span> 件</td>

                    <!------------------------------------------------------------------
                    <-- (発生中警報)重故障
                    <------------------------------------------------------------------>
                    <td style="text-align:right;"><span>{{ numComma(item.alert_info.binary_major) }}</span> 件</td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)空調
                    <------------------------------------------------------------------>
                    <td
                      v-bind:class="getAlertNotify(item.device_info.aircon.alert_count)"
                      style="text-align:center;"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="onDetailDevice(item.account, item.device_info.aircon.using, 1)"
                      >
                        <img v-bind:src="getDeviceAirConditionerIconUrl(item.device_info.aircon.using)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)受変電
                    <------------------------------------------------------------------>
                    <td
                      v-bind:class="getAlertNotify(item.device_info.receiver.alert_count)"
                      style="text-align:center;"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="onDetailDevice(item.account, item.device_info.receiver.using, 2)"
                      >
                        <img v-bind:src="getDeviceReceiverIconUrl(item.device_info.receiver.using)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)発電
                    <------------------------------------------------------------------>
                    <td
                      v-bind:class="getAlertNotify(item.device_info.generator.alert_count)"
                      style="text-align:center;"
                    >
                      <a
                        href="javascript:void(0);"
                        @click="onDetailDevice(item.account, item.device_info.generator.using, 4)"
                      >
                        <img v-bind:src="getDeviceGeneratorIconUrl(item.device_info.generator.using)" />
                      </a>
                    </td>

                    <!------------------------------------------------------------------
                    <-- (設備一覧)その他
                    <------------------------------------------------------------------>
                    <td style="text-align:center;">
                      <img v-bind:src="getDeviceElectricIconUrl()" />
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

    </div>

    <LoadExternalJS :url="fixedMidashiUrl"></LoadExternalJS>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Store from "../../store";
import Axios from "axios";
import LoadExternalJS from "../../components/LoadExternalJS";

export default {
  name: "activity",
  components: {
    LoadExternalJS
  },
  data: function() {
    return {
      group_info: {
        activities: []
      },
      power_info: {
        activities: [],
        filter_activities: [],
        filter_info: {
          parent_name: "",
          account: "",
          company_name: "",
          sales_center_id: 0,
          sales_office_id: 0,
          sales_office_ids: []
        },
        sort_info: {
          sort_type: "",
          sort_order: 0
        }
      },
      es_info: {
        activities: [],
        filter_activities: [],
        filter_info: {
          parent_name: "",
          account: "",
          company_name: "",
          sales_center_id: 0,
          sales_office_id: 0,
          sales_office_ids: []
        },
        sort_info: {
          sort_type: "",
          sort_order: 0
        }
      },
      fixedMidashiUrl: "./assets/js/fixed_midashi.js"
    };
  },

  mounted: function() {
    var tab;
    var tab_item;
    var children;

    if (this.$store.state.loginType == 3) {
      tab = document.getElementById('tab_info');
      children = tab.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == 'tab_power') {
          children[i].className = "tab active";
        } else {
          children[i].className = "tab inactive";
        }
      }

      tab_item = document.getElementById('page_info');
      children = tab_item.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == 'tab_power') {
          children[i].style.display = "block";
        } else {
          children[i].style.display = "none";
        }
      }
    }
  },

  computed: {
    visibleActivities: function() {
      const limit = this.$store.state.activity.limit;
      console.log(limit);
      const index = this.$store.state.activity.index;
      return this.activities.slice((index - 1) * limit, index * limit);
    },

    pagenation: function() {
      const numOfPages = this.$store.state.activity.numOfPages;
      let temp = [];
      for (let index = 0; index < numOfPages; index++) {
        temp.push(index + 1);
      }
      return temp;
    }
  },

  watch: {
    'power_info.filter_info.sales_center_id': function(newValue, oldValue) {
      console.log("power_info.filter_info.sales_center_id");
      console.log("newValue:" + newValue + ", oldValue" + oldValue);

      let office = this.$store.state.salesOfficeMaster.filter(
        obj => obj.sales_center_id == newValue
      );
      this.power_info.filter_info.sales_office_id = 0;
      this.power_info.filter_info.sales_office_ids = office;
    },

    'es_info.filter_info.sales_center_id': function(newValue, oldValue) {
      console.log("es_info.filter_info.sales_center_id");
      console.log("newValue:" + newValue + ", oldValue" + oldValue);

      let office = this.$store.state.salesOfficeMaster.filter(
        obj => obj.sales_center_id == newValue
      );
      this.es_info.filter_info.sales_office_id = 0;
      this.es_info.filter_info.sales_office_ids = office;
    }
  },

  updated: function() {
    window.FixedMidashi.remove();
    window.FixedMidashi.create();
  },

  created: function() {
    const self = this;
    console.log("created");
    console.log(Store.state.childID);

    this.$axios
      .get(`/srv/api/sales_center_master`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        Store.dispatch(
          "setSalesCenterMaster",
          response.data["sales_center_master"]
        );
      })
      .catch(error => {
        console.log(error);
      });
    this.$axios
      .get(`/srv/api/sales_office_master`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        Store.dispatch(
          "setSalesOfficeMaster",
          response.data["sales_office_master"]
        );
      })
      .catch(error => {
        console.log(error);
      });
    this.$axios
      .get(`/srv/api/weather_area_relation_master`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        Store.dispatch(
          "setWeatherAreaRelationMaster",
          response.data["weather_area_relation_master"]
        );
      })
      .catch(error => {
        console.log(error);
      });
    this.$axios
      .get(`/srv/api/chain_store_list/${Store.state.loginID}`, {
        withCredentials: true
      })
      .then(response => {
        console.log("chain_store_list success");
        console.log(response.data);
        if (typeof response.data == "object") {
          self.group_info.activities = response.data.activity;
console.log("==========");
console.log(self.group_info.activities);
          console.log(self.group_info.activities);
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log("chain_store_list error");
        console.log(error);
      });
    this.$axios
      .get("/srv/api/activity_list", {
        withCredentials: true
      })
      .then(response => {
        console.log("success");
        console.log(response.data);
        if (typeof response.data == "object") {
          self.power_info.activities = response.data.activityPowerList;
          self.power_info.filter_activities = response.data.activityPowerList;
          Store.dispatch(
            "setActivityList",
            response.data["activity"]
          );
          //this.$store.dispatch("activityPageReset", self.activities.length);
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log("activity_list error");
        console.log(error);
      });
    this.$axios
      .get("/srv/api/activity_list_es", {
        withCredentials: true
      })
      .then(response => {
        console.log("success");
        console.log(response.data);
        if (typeof response.data == "object") {
          self.es_info.activities = response.data.activityEsList;
          self.es_info.filter_activities = response.data.activityEsList;
          Store.dispatch(
            "setActivityList",
            response.data["activity"]
          );
          //this.$store.dispatch("activityPageReset", self.activities.length);
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log("activity_list_es error");
        console.log(error);
      });
  },

  methods: {
    normalizeForecastDemand: function(value) {
      const forecast_demand = parseFloat(value);
      if (isNaN(forecast_demand)) {
        return "-";
      } else {
        return Number(Math.ceil(forecast_demand)).toLocaleString();
      }
    },

    onClickData: function(index) {
      console.log("onClickData");
      console.log(this.visibleActivities[index]);
    },

    onDetail: function(account, selectedDevice) {
      console.log(account + '-----' + selectedDevice);
      if (!this.$store.state.isConfirmed) {
        const confirmPassword = prompt("子アカウント操作確認用パスワード入力");
        if (confirmPassword != null) {
          console.log("confirmChildAccount");
          const params = new URLSearchParams();
          params.append("password", confirmPassword);
          const self = this;
          this.$axios
            .post(`/srv/api/confirm/`, params, {
              withCredentials: true
            })
            .then(response => {
              console.log(response);
              const data = response.data;
              if (data.status !== undefined) {
                if (data.status === "success") {
                  self.$store.dispatch("setConfirm", { isConfirmed: true });
                  self.$store.dispatch("setChildID", account);
                  self.$store.dispatch("setSelectedDevice", selectedDevice);
                  let route = this.$router.resolve({path: '/'});
                  if (selectedDevice > 0) {
                    route = this.$router.resolve({path: '/es/system_diagram_display'});
                  }
                  window.open(route.href, '_blank');
                } else {
                  console.log("error");
                  alert("子アカウント操作確認できませんでした。");
                  self.$store.dispatch("setConfirm", { isConfirmed: false });
                }
              } else {
                console.log("error");
                alert("子アカウント操作確認できませんでした。");
                self.$store.dispatch("setConfirm", { isConfirmed: false });
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          //
        }
      } else {
        this.$store.dispatch("setChildID", account);
        this.$store.dispatch("setSelectedDevice", selectedDevice);
        let route = this.$router.resolve({path: '/'});
        if (selectedDevice > 0) {
          route = this.$router.resolve({path: '/es/system_diagram_display'});
        }
        window.open(route.href, '_blank');
      }
    },

    onDetailDevice: function(account, using, selectedDevice) {
      if (using) {
        this.onDetail(account, selectedDevice);
      }
    },

    onDetailPower: function(name) {
      this.power_info.filter_info.parent_name = name;
      this.onFilterPower();
      this.onTabClick('tab_power');
    },

    onDetailEs: function(name) {
      this.es_info.filter_info.parent_name = name;
      this.onFilterEs();
      this.onTabClick('tab_es');
    },

    onDetailParent: function(account, supplyManagement) {
      console.log(account);
      if (!this.$store.state.isConfirmed) {
        const confirmPassword = prompt("親アカウント操作確認用パスワード入力");
        if (confirmPassword != null) {
          console.log("confirmChildAccount");
          const params = new URLSearchParams();
          params.append("password", confirmPassword);
          const self = this;
          this.$axios
            .post(`/srv/api/confirm/`, params, {
              withCredentials: true
            })
            .then(response => {
              console.log(response);
              const data = response.data;
              if (data.status !== undefined) {
                if (data.status === "success") {
                  self.$store.dispatch("setConfirm", { isConfirmed: true });
                  self.$store.dispatch("setParentID", account);

                  // 電衛門
                  // let route = this.$router.resolve({path: '/shop'});
                  // if (supplyManagement == true) {
                  //   route = this.$router.resolve({path: '/shop/shop_aggregation'});
                  // }

                  // 多回路独自
                  let route = this.$router.resolve({path: '/shop/multi_circuit_graph_list'});

                  window.open(route.href, '_blank');
                } else {
                  console.log("error");
                  alert("親アカウント操作確認できませんでした。");
                  self.$store.dispatch("setConfirm", { isConfirmed: false });
                }
              } else {
                console.log("error");
                alert("親アカウント操作確認できませんでした。");
                self.$store.dispatch("setConfirm", { isConfirmed: false });
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          //
        }
      } else {
        this.$store.dispatch("setParentID", account);

        // 電衛門
        // let route = this.$router.resolve({path: '/shop'});
        // if (supplyManagement == true) {
        //   route = this.$router.resolve({path: '/shop/shop_aggregation'});
        // }

        // 多回路独自
        let route = this.$router.resolve({path: '/shop/multi_circuit_graph_list'});

        window.open(route.href, '_blank');
      }
    },

    onGotoPage: function(index) {
      this.$store.dispatch("setActivityPageIndex", index);
    },

    onPrev: function() {
      console.log("onPrev");
      this.$store.dispatch("activityPagePrev");
    },

    onNext: function() {
      console.log("onPrev");
      this.$store.dispatch("activityPageNext");
    },

    onFilterPower: function() {
      console.log("onFilterPower");
      console.log(
        "parent_name:" + this.power_info.filter_info.parent_name + ", " +
        "account:" + this.power_info.filter_info.account + ", " +
        "company_name:" + this.power_info.filter_info.company_name + ", " +
        "sales_center_id:" + this.power_info.filter_info.sales_center_id + ", " +
        "sales_office_id:" + this.power_info.filter_info.sales_office_id
      );

      this.power_info.filter_activities = this.power_info.activities;

      if (this.power_info.filter_info.parent_name) {
        const list = this.power_info.filter_activities.filter(
          item => (
                    ((item.parent_name != null) && (item.parent_name.indexOf(this.power_info.filter_info.parent_name) > -1))
                  )
        );
        this.power_info.filter_activities = list;
      }

      if (this.power_info.filter_info.account) {
        const list = this.power_info.filter_activities.filter(
          item => (
                    ((item.account != null) && (item.account.indexOf(this.power_info.filter_info.account) > -1))
                  )
        );
        this.power_info.filter_activities = list;
      }

      if (this.power_info.filter_info.company_name) {
        const list = this.power_info.filter_activities.filter(
          item => (
                    ((item.name != null) && (item.name.indexOf(this.power_info.filter_info.company_name) > -1))
                  )
        );
        this.power_info.filter_activities = list;
      }

      if (this.power_info.filter_info.sales_center_id) {
        const list = this.power_info.filter_activities.filter(
          obj => obj.sales_center_id == this.power_info.filter_info.sales_center_id
        );
        this.power_info.filter_activities = list;
      }

      if (this.power_info.filter_info.sales_office_id) {
        const list = this.power_info.filter_activities.filter(
          obj => obj.sales_office_id == this.power_info.filter_info.sales_office_id
        );
        this.power_info.filter_activities = list;
      }
    },

    onFilterEs: function() {
      console.log("onFilterEs");
      console.log(
        "parent_name:" + this.es_info.filter_info.parent_name + ", " +
        "account:" + this.es_info.filter_info.account + ", " +
        "company_name:" + this.es_info.filter_info.company_name + ", " +
        "sales_center_id:" + this.es_info.filter_info.sales_center_id + ", " +
        "sales_office_id:" + this.es_info.filter_info.sales_office_id
      );

      this.es_info.filter_activities = this.es_info.activities;

      if (this.es_info.filter_info.parent_name) {
        const list = this.es_info.filter_activities.filter(
          item => (
                    ((item.parent_name != null) && (item.parent_name.indexOf(this.es_info.filter_info.parent_name) > -1))
                  )
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.account) {
        const list = this.es_info.filter_activities.filter(
          item => (
                    ((item.account != null) && (item.account.indexOf(this.es_info.filter_info.account) > -1))
                  )
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.company_name) {
        const list = this.es_info.filter_activities.filter(
          item => (
                    ((item.name != null) && (item.name.indexOf(this.es_info.filter_info.company_name) > -1))
                  )
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.sales_center_id) {
        const list = this.es_info.filter_activities.filter(
          obj => obj.sales_center_id == this.es_info.filter_info.sales_center_id
        );
        this.es_info.filter_activities = list;
      }

      if (this.es_info.filter_info.sales_office_id) {
        const list = this.es_info.filter_activities.filter(
          obj => obj.sales_office_id == this.es_info.filter_info.sales_office_id
        );
        this.es_info.filter_activities = list;
      }
    },

    onSortPower: function(type) {
      console.log("onSortPower");

      let sortOrder = 0;

      if (this.power_info.sort_info.sort_type == type) {
        this.power_info.sort_info.sort_order = (this.power_info.sort_info.sort_order === 1) ? 0 : 1;
      } else {
        this.power_info.sort_info.sort_order = 0;
      }
      this.power_info.sort_info.sort_type = type;
      sortOrder = this.power_info.sort_info.sort_order;

      if (type == "control_status") {
        this.power_info.filter_activities.sort(function(a, b) {
          let data1 = eval(`a.${type}`);
          let data2 = eval(`b.${type}`);
          if (a['air_conditioner_control'] == true) {
            data1 += (data1 == 1 ? 2 : 0)
            data1 += 10;
          }
          if (b['air_conditioner_control'] == true) {
            data2 += (data2 == 1 ? 2 : 0)
            data2 += 10;
          }
          if (sortOrder == 0) {
            return (data1 < data2) ? -1 : (data1 > data2) ? 1 : 0;
          } else {
            return (data1 < data2) ? 1 : (data1 > data2) ? -1 : 0;
          }
        });
      } else {
        this.power_info.filter_activities.sort(function(a, b) {
          let data1 = eval(`a.${type}`);
          let data2 = eval(`b.${type}`);
          if (sortOrder == 0) {
            return (data1 < data2) ? -1 : (data1 > data2) ? 1 : 0;
          } else {
            return (data1 < data2) ? 1 : (data1 > data2) ? -1 : 0;
          }
        });
      }
    },

    onSortEs: function(type) {
      console.log("onSortEs");

      let sortOrder = 0;

      if (this.es_info.sort_info.sort_type == type) {
        this.es_info.sort_info.sort_order = (this.es_info.sort_info.sort_order === 1) ? 0 : 1;
      } else {
        this.es_info.sort_info.sort_order = 0;
      }
      this.es_info.sort_info.sort_type = type;
      sortOrder = this.es_info.sort_info.sort_order;

      this.es_info.filter_activities.sort(function(a, b) {
        let data1 = eval(`a.${type}`);
        let data2 = eval(`b.${type}`);
        if (sortOrder == 0) {
          return (data1 < data2) ? -1 : (data1 > data2) ? 1 : 0;
        } else {
          return (data1 < data2) ? 1 : (data1 > data2) ? -1 : 0;
        }
      });
    },

    onTabClick: function(tab_name) {
      var tab;
      var tab_item;
      var children;

      tab = document.getElementById('tab_info');
      children = tab.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == tab_name) {
          children[i].className = "tab active";
        } else {
          children[i].className = "tab inactive";
        }
      }

      tab_item = document.getElementById('page_info');
      children = tab_item.children;
      for(let i = 0; i < children.length; i++) {
        if (children[i].id == tab_name) {
          children[i].style.display = "block";
        } else {
          children[i].style.display = "none";
        }
      }
    }

  }
};
</script>
